import React from 'react';
import PropTypes from 'prop-types';

const SVGWrap = ({ children, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={style}>
    {children}
  </svg>
);

SVGWrap.defaultProps = {
  style: {},
};

SVGWrap.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default SVGWrap;
